import { render, staticRenderFns } from "./RouterRevista.vue?vue&type=template&id=c47293a4&"
import script from "./RouterRevista.vue?vue&type=script&lang=js&"
export * from "./RouterRevista.vue?vue&type=script&lang=js&"
import style0 from "./RouterRevista.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports